import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "39",
  height: "38",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M38.612 18.863c0 10.455-8.468 18.85-18.85 18.85a18.79 18.79 0 0 1-18.85-18.85C.912 8.48 9.306.012 19.762.012c10.382 0 18.85 8.467 18.85 18.85m-24.74-6.48v12.96c0 .662.294 1.25.883 1.546.515.368 1.251.294 1.767 0l10.603-6.48c.515-.295.884-.884.884-1.546 0-.59-.369-1.179-.884-1.473l-10.603-6.48a1.55 1.55 0 0 0-1.767 0c-.59.295-.884.884-.884 1.473"
    }, null, -1)
  ])))
}
export default { render: render }